<div class="content">
  <h2 style="margin: 0">Settings</h2>
  <br>

  <h3 style="margin-top: 0vh">Config file SMTP</h3>
  <label>Host</label>
  <br>
  <input [(ngModel)]="SMTPConfig.host" type="text">
  <br>
  <br>
  <label>Port</label>
  <br>
  <input [(ngModel)]="SMTPConfig.port" type="number">
  <br>
  <br>

  <label>Secure</label>
  <br>
  <input [(ngModel)]="SMTPConfig.secure" type="checkbox">
  <br>
  <br>

  <label>Username</label>
  <br>
  <input [(ngModel)]="SMTPConfig.auth.user" type="text">
  <br>
  <br>

  <label>Password</label>
  <br>
  <input [(ngModel)]="SMTPConfig.auth.pass" type="text">
  <br>
  <br>

  <labeL>Select incoming server type</labeL>
  <div id="receive-options">
    <p-selectButton [options]="receiveOptions" [(ngModel)]="selectedOption"></p-selectButton>
  </div>

  <br>
  <div *ngIf="selectedOption=='IMAP'" id="imap-settings">
    <h3 style="margin-top: 1vh">Config file IMAP</h3>
    <label>Host</label>
    <br>
    <input [(ngModel)]="IMAPConfig.host" type="text">
    <br>
    <br>
    <label>Port</label>
    <br>
    <input [(ngModel)]="IMAPConfig.port" type="number">
    <br>
    <br>

    <label>Secure</label>
    <br>
    <input [(ngModel)]="IMAPConfig.tls" type="checkbox">
    <br>
    <br>

    <label>Username</label>
    <br>
    <input [(ngModel)]="IMAPConfig.user" type="text">
    <br>
    <br>

    <label>Password</label>
    <br>
    <input [(ngModel)]="IMAPConfig.password" type="text">
    <br>
    <br>
  </div>

  <div *ngIf="selectedOption=='POP3'" id="pop-settings">
    <h3 style="margin-top: 1vh">Config file POP3</h3>
    <label>Host</label>
    <br>
    <input [(ngModel)]="POP3Config.host" type="text">
    <br>
    <br>
    <label>Port</label>
    <br>
    <input [(ngModel)]="POP3Config.port" type="number">
    <br>
    <br>

    <label>Secure</label>
    <br>
    <input [(ngModel)]="POP3Config.tls" type="checkbox">
    <br>
    <br>

    <label>Username</label>
    <br>
    <input [(ngModel)]="POP3Config.user" type="text">
    <br>
    <br>

    <label>Password</label>
    <br>
    <input [(ngModel)]="POP3Config.password" type="text">
    <br>
    <br>
  </div>

  <div *ngIf="selectedOption" id="save-load">
    <button (click)="loadConfigs()">Load Configuration</button>
    <button (click)="saveConfigs()">Save Configuration</button>
  </div>

</div>
